// Import style lib
import styled from 'styled-components';

// Import colors
import colors from '../../utils/styles/colors';

// Create a styled error message
export const ErrorMessageText = styled.p.withConfig({
    shouldForwardProp: (prop) => !['critical'].includes(prop),
})`
    /* Apperance */
    ${(props) =>
        props.critical ? `color: ${colors.textBlack};` : 'color: red;'}
`;

// Styled error message stack
export const ErrorMessageStackContainer = styled.div`
    /* Content disposition */
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
`;
